<template>
  <div class="container">
    <img class="imgLogo" src="../../assets/img/login/logo.png" alt />
    <div id="imgpm" class="slideshow">
      <div
        v-for="(item,index) in bgImgs"
        :key="index"
        class="slideshow-image"
        :style="{background: `url(${item})`}"
      ></div>
    </div>
    <div class="content">
      <!-- <div class="conLeft">
        <div class="logo"></div>
        <div class="titleLfet">陈皮溯源</div>
      </div>-->
      <el-form :model="form" :rules="rules" ref="ruleForm" class="conRight">
        <div class="title mb">密码登录</div>
        <el-form-item class="user mb" prop="phone">
          <el-input
            v-model="form.phone"
            size="large"
            placeholder="请输入手机号码"
            prefix-icon="el-icon-user"
          />
        </el-form-item>
        <el-form-item class="password" prop="password">
          <el-input
            v-model="form.password"
            size="large"
            show-password
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
          />
        </el-form-item>

        <!--    记住密码...        -->
        <template>
          <div class="switch-btn">
            <el-checkbox v-model="form.rememberMe" label="记住密码"></el-checkbox>
          </div>
          <div class="agreement" id="isCheck">
            <el-checkbox v-model="form.isCheck" checked>
              已阅读并同意
              <router-link target="_blank" :to="{ path: '/userAgreement' }">
                《
                <span>用户协议</span>》
              </router-link>和
              <router-link target="_blank" :to="{ path: '/privacyPolicy' }">
                《
                <span>隐私政策</span>》
              </router-link>
              <div class="el-form-item__error agreementValidate" v-if="form.isShow">请阅读用户协议和隐私政策</div>
            </el-checkbox>
          </div>
          <!-- <div class="submit">
            <button @click.prevent="handleLogin">登录</button>
          </div>-->
        </template>
        <!-- <el-form-item class="code" prop="codeIup">
          <div class="codeTitle">验证码</div>
          <div class="codeContent">
            <div class="codeInp">
              <el-input v-model="form.codeIup" class="w-50 m-2" size="large" />
            </div>
            <div class="codeTxt">
              <canvas id="canvas" ref="canvas" class="canvasC" @click="refreshCode"></canvas>
            </div>
            <div class="codebtn" @click="refreshCode">看不清？点我换一张</div>
          </div>
        </el-form-item>-->
        <div class="msg">{{ msg }}</div>
        <div class="submit mb" @click="submit">登录</div>
      </el-form>
    </div>
    <!--    底部        -->
    <div class="login_footer">
      <ul>
        <li class="logo_name">
          Copyright ©
          <span>2021-2024</span>
          <!-- <img class="emblem" src="@/assets/img/emblem.png" alt /> -->
          <a class="ainline" href="https://beian.miit.gov.cn/#/Integrated/index">粤2022068619号</a>

          <br />
          <a href="javascript:;">
            <span>亚太陈皮溯源系统(V2.3.0)</span>
          </a>
          <!-- <br> -->
          <!-- <a href>Asia Pacific Intelligence (Shenzhen) Technology Co., Ltd</a> -->
        </li>
        <li class="name_eng"></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { refreshCode } from './common'
import { login } from '../../api/login'
import { getUserInfo } from '@/api/system/system'
export default {
  data() {
    const validateCode = (rule, value, callback) => {
      if (value == '' || !value) {
        callback(new Error('验证码不能为空'))
      } else if (value.toLowerCase() !== this.validCode.toLowerCase()) {
        callback(new Error('校验错误'))
      } else {
        callback()
      }
    }
    return {
      bgImgs: [
        require('@/assets/img/login/login-background1.jpg'),
        require('@/assets/img/login/login-background2.jpg'),
        require('@/assets/img/login/login-background3.jpg'),
        // require("@/assets/img/login-background4.jpg"),
      ],
      form: {
        phone: '',
        password: '',
        loginTypeEnum: 'password',
      },
      validCode: '',
      msg: '',
      rules: {
        phone: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
        password: [{ required: true, message: '请输入登录密码', trigger: 'blur' }],
        codeIup: [
          {
            required: true,
            trigger: '',
            validator: validateCode,
          },
        ],
      },
    }
  },
  mounted() {
    // this.refreshCode()
    this.form.phone = sessionStorage.getItem('phone')
    this.form.password = sessionStorage.getItem('password')
  },
  methods: {
    refreshCode() {
      // 保存生成的验证码
      this.validCode = refreshCode(this.$refs.canvas)
    },
    submit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          // this.$router.push('/home')
          login(this.form)
            .then((res) => {
              // console.log(res, 'resresresresresres-----------------')
              if (res.flag) {
                console.log('-------------------------------111111111111111111')
                sessionStorage.setItem('token', res.data)

                getUserInfo()
                  .then((res) => {
                    console.log(res, 'resresresresresres-----------------')
                    if (res.flag) {
                      console.log('-------------------------------111111111111111111')
                      let pcMenuList = []
                      let pcPerms = res.data.pcPerms

                      res.data.pcMenuList.forEach((ele) => {
                        pcMenuList.push({
                          path: ele.path,
                          component: ele.component,
                          menuName: ele.menuName,
                          icon: ele.icon,
                          id: ele.id,
                          parentId: ele.parentId,
                          visible: ele.visible,
                          menuType: ele.menuType,
                        })
                      })
                      if (this.form.rememberMe) {
                        sessionStorage.setItem('password', this.form.password)
                      } else {
                        sessionStorage.setItem('password', '')
                      }
                      sessionStorage.setItem('phone', this.form.phone)

                      sessionStorage.setItem('nickName', res.data.userName)
                      sessionStorage.setItem('menuList', JSON.stringify(pcMenuList))
                      sessionStorage.setItem('pcPerms', JSON.stringify(pcPerms))
                      this.$router.push('/home')
                    } else {
                      // this.refreshCode()
                    }
                  })
                  .catch((error) => {
                    console.log('error----------------1')
                    this.$message.error('登录失败，' + error.message)
                  })
              } else {
                this.$message.error(res.message)
                // this.refreshCode()
              }
            })
            .catch((error) => {
              this.$message.error(error.message)
            })
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../assets/variables.less';
@import '../../assets/sideShow.css';
ul {
  list-style-type: none;
}
ul {
  list-style: none;
}
.imgLogo {
  width: 100px;
  height: 100px;
  position: absolute;
  left: 3%;
  top: 5%;
}
a {
  text-decoration: none;
  color: #fff;
}
// 已阅读并同意......
.agreement {
  // margin-bottom: 20px;
  // padding-left: 30px;
  position: relative;
  .el-checkbox {
    ::v-deep .el-checkbox__label {
      color: #ffffff;
    }
    span {
      color: #ac0013 !important;
      &:hover {
        color: #ff9100 !important;
      }
    }
    .agreementValidate {
      padding-left: 24px !important;
    }
  }
}
// 记住密码
.switch-btn {
  margin-bottom: 17px;
  // padding: 0 30px;
  .el-checkbox {
    ::v-deep .el-checkbox__label {
      color: #ffffff;
    }
  }
}
/deep/.el-form-item__content {
  line-height: 0 !important;
}

.mb {
  font-size: 18px;
  // margin-top: 2rem;
  // width: 400px;
}

.container {
  // background-color: red;
  background-size: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  // font-size: 2.1rem;
}

.content {
  width: 360px !important;
  position: fixed;
  top: 160px;
  left: 65%;
  z-index: 999;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 0.3em;
  box-shadow: 0 0.5em 1em rgba(0, 0, 0, 0.3);
  padding: 20px 30px 20px 30px;
  box-sizing: border-box;
}

.logo {
  width: 13.8rem;
  height: 13.8rem;
}

.logo img {
  width: 100%;
  height: 100%;
}

.titleLfet {
  font-size: 3.6rem;
  font-weight: 500;
  color: @primary-color;
  line-height: 5.4rem;
  margin-top: 3.5rem;
}

.conRight {
  // display: flex;
  // flex-direction: column;
  // align-items: flex-start;
  // justify-content: center;
}

.submit {
  // width: 400px;
  margin-top: 20px;
  margin-bottom: 20px;
  height: 40px;
  background-color: @primary-color;
  border-radius: 2rem;
  color: #fff;
  text-align: center;
  line-height: 40px;
  background: #c59429;
  cursor: pointer;
}

.title {
  font-size: 16px;
  margin-bottom: 15px;
  font-weight: 700;
  color: #fff;
  line-height: 36px;
  text-align: center;
}

.codeTitle {
  font-size: 2rem;
  font-family: NotoSansHans-Regular, NotoSansHans;
  font-weight: 400;
  color: @primary-color;
  line-height: 3.6rem;
  margin-bottom: 1rem;
}

.codeContent {
  display: flex;
  flex-direction: row;
}

.link {
  position: absolute;
  bottom: 1rem;
  text-align: center;
  color: #fff;
  width: 100%;
  cursor: pointer;
}

.codeTxt {
  margin: 0 5rem;
  // background-color:red ;
}

.code {
  padding: 0px 0.9rem;
  box-sizing: border-box;
  width: 45rem;
}

.codebtn {
  line-height: 2rem;
  cursor: pointer;
  font-size: 1.5rem;
  height: 100%;
  position: relative;
}
// 底部
.login_footer {
  max-width: 630px;
  color: #fff;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 999;

  ul {
    li {
      margin: 14px 0;
      text-align: center;

      &:first-child {
        margin: 0;
      }

      &:last-child {
        margin-top: 0;
      }
    }

    .login_device {
      a {
        margin-left: 20px;
        display: inline-table;
        cursor: default;

        img,
        .hmos {
          width: 30px;
          display: block;
          margin: 0 auto;
        }

        .hmos {
          /* prettier-ignore */
          font-size: 25px;
        }

        span {
          /* prettier-ignore */
          font-size: 12px;
        }

        &:first-child {
          margin-left: 0;
        }
      }
    }

    .logo_name {
      img {
        width: 100px;
      }

      span {
        /* prettier-ignore */
        /* prettier-ignore */
        font-size: 12px;
      }

      a {
        color: #fff;
        letter-spacing: 2px;
        cursor: default;
      }

      .emblem {
        width: 18px;
      }
    }

    .name_eng {
      a {
        color: #fff;
        /* prettier-ignore */
        font-size: 14px;

        letter-spacing: 1px;
        cursor: default;
      }
    }
  }
}
</style>
